module.exports = __webpack_public_path__ + "static/card-grants-program-overview-8878643269e8d8a0271b1e2721086631.jpg";